export default "__VITE_ASSET__6614675e__"